var map = {
	"./alien.png": 34986,
	"./black.png": 88854,
	"./blank.png": 24057,
	"./blue.png": 36454,
	"./diamond.png": 27141,
	"./gold.png": 71193,
	"./green.png": 48234,
	"./lobo.png": 50222,
	"./mythical.png": 93000,
	"./orange.png": 97063,
	"./phantom.png": 18310,
	"./pink.png": 13294,
	"./purple.png": 4257,
	"./red.png": 59239,
	"./silver.png": 10674,
	"./skeleton.png": 43114,
	"./yellow.png": 54165,
	"./zombie.png": 63560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81389;